import script from "./SiteManagementTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteManagementTable.vue?vue&type=script&setup=true&lang=js"

import "./SiteManagementTable.vue?vue&type=style&index=0&id=1a2a5990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a2a5990"]])

export default __exports__